import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { merge } from "lodash-es";

import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { Modal } from "shared/components";
import {
  BAND_ACTIONS,
  IPeopleBlockParams,
  IPeopleBlockUser,
} from "Bands/types";
import { PeopleBlockStatusForm } from "Bands/components";
import {
  dataMetaSelector,
  dispatchGetEventPeopleBlock,
  editPeopleBlockUser,
} from "Bands/state";
import { BAND_PATHS } from "Bands/router";
import { getMemberName, useClearActionMetaOnUnMount } from "Bands/utils";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";

const peopleBlockCopy = copy.peopleBlock.editStatus;

interface EditStatusModalProps {
  blockId: string;
  user: IPeopleBlockUser;
  handleClose: () => void;
}

export const EditStatusModal: FC<EditStatusModalProps> = ({
  blockId,
  user,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.editPeopleBlockUser)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.editPeopleBlockUser);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatchGetEventPeopleBlock(dispatch, blockId);

      dispatch(
        addTemporaryToast({
          message: peopleBlockCopy.messages.edited,
          status: IStatus.success,
        })
      );
    }
  }, [apiMeta?.status, blockId, dispatch, handleClose]);

  const handleSubmit = (data: IPeopleBlockParams) => {
    dispatch(
      editPeopleBlockUser({
        id: user.id,
        data: merge({}, data, {
          rsvpUrl: `${window.location.origin}${BAND_PATHS.ANSWER_RSVP}?token=[TOKEN]&status=[STATUS]`,
        }),
      })
    );
  };

  return (
    <Modal
      title={peopleBlockCopy.title.replace("%name", getMemberName(user.user))}
      icon={User}
      handleClose={handleClose}
    >
      <PeopleBlockStatusForm
        currentStatus={user.status}
        handleCancel={handleClose}
        handleSubmit={handleSubmit}
        apiStatus={apiMeta?.status}
        error={!!apiMeta?.error}
        apiError={apiMeta?.error}
      />
    </Modal>
  );
};
